/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Alt_Meta_DescInputs */

const en_pc_alt_meta_desc = /** @type {(inputs: Pc_Alt_Meta_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`When PdfCraft is the right PDF editor and when it isn't, compared plainly with Adobe Acrobat, Foxit PDF Editor, PDFsam Basic, Okular and the PDFCraftTool browser toolkit.`)
};

const zh_pc_alt_meta_desc = /** @type {(inputs: Pc_Alt_Meta_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PdfCraft 适合什么场景、不适合什么场景，并与 Adobe Acrobat、Foxit PDF Editor、PDFsam Basic、Okular 以及 PDFCraftTool 浏览器工具集进行客观对比。`)
};

/**
* | output |
* | --- |
* | "When PdfCraft is the right PDF editor and when it isn't, compared plainly with Adobe Acrobat, Foxit PDF Editor, PDFsam Basic, Okular and the PDFCraftTool bro..." |
*
* @param {Pc_Alt_Meta_DescInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_alt_meta_desc = /** @type {((inputs?: Pc_Alt_Meta_DescInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Alt_Meta_DescInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_alt_meta_desc(inputs)
	return zh_pc_alt_meta_desc(inputs)
});
export { pc_alt_meta_desc as "pc.alt.meta_desc" }